<template>
  <b-card>

    <b-form-row class="filter-container mb-2 d-flex justify-content-between align-items-center flex-nowrap">
      <div class="d-flex justify-content-between align-items-center">
        <span class="ml-1 mr-2">ფილტრი: </span>
        <b-form-group label-for="institutions"
                      class="mr-2 mb-0"
                      v-slot="{ ariaDescribedby }">
          <b-input-group>
            <b-form-select id="institutions"
                           v-model="selectedInstitution"
                           :options="institutions"
                           :aria-describedby="ariaDescribedby"
                           class="w-75">
              <template #first>
                <b-form-select-option :value="null" disabled>აირჩიე დაწესებულება</b-form-select-option>
              </template>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <b-button variant="primary" class="" @click="filterTable(false)">
          <feather-icon icon="FilterIcon" class="mr-50"/>
          <span class="align-middle">გაფილტვრა</span>
        </b-button>
        <b-button variant="secondary" class="ml-1" @click="filterTable(true)">
          <feather-icon icon="TrashIcon" class="mr-50"/>
          <span class="align-middle">გასუფთავება</span>
        </b-button>
      </div>

    </b-form-row>

    <b-col></b-col>

    <b-table responsive="sm"
             :fields="columns"
             outlined
             hover
             small
             :title="title"
             fixed
             show-empty
             :empty-text="emptyText"
             id="index-patients-table"
             @row-clicked="rowClickHandler"
             :class="className"
             :items="rows">

      <template #cell(actions)="data" td-class="text-right">
        <b-button variant="flat-danger" class="btn-icon" @click="warning(data)">
          <feather-icon icon="Trash2Icon"/>
        </b-button>
      </template>

      <template #cell(risk_factors)="data">
        <div class="">
          <p v-for="risk in data.item.risk_factors" v-bind:key="risk">{{ risk }}</p>
        </div>
      </template>

      <template #cell(institutions)="data">
        <ul class="">
          <li v-for="institution in data.item.institutions" v-bind:key="institution">{{ institution }} </li>
        </ul>
      </template>

      <template #cell(medication)="data">
<!--        <span>{{data.item.medication}}</span>-->
        <span v-if="data.item.treatmentCompleted">დასრულებული</span>
        <span v-else>{{data.item.medication}}</span>
      </template>

      <template #cell(next)="data">
        <span v-if="data.item.next">{{ formatDate(data.item.next) }}</span>
        <span v-else>ჯერ არ არის დამატებული</span>
      </template>
    </b-table>

    <div v-if="paging" class="card-footer-container d-flex justify-content-between align-items-center pt-2 pb-1">
      <div class="title-container d-flex align-items-center">
        <span v-if="!isLastPage" class="text-muted">ნაჩვენებია {{ perPage * currentPage }}/{{ totalCount }}</span>
        <span v-else class="text-muted">ნაჩვენებია {{ totalCount }}/{{ totalCount }}</span>
      </div>

      <b-pagination
          v-model="currentPage"
          :total-rows="totalCount"
          :per-page="perPage"
          aria-controls="index-patients-table"
          @page-click="pageChanged"
      ></b-pagination>
    </div>

  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
  BPagination,
  BCol,
  BFormRow,
  BFormGroup,
  BInputGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue"
import moduleInstitutions from "@/store/institution/moduleInstitution";

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BPagination,
    BCol,
    BFormRow,
    BFormGroup,
    BInputGroup,
    BFormSelect,
    BFormSelectOption,
  },
  props: ["rows", "title", "columns", "className", "paging", "accounts_meta", "emptyText"],

  data() {
    return {
      perPage: 15,
      currentPage: 1,
      boxTwo: "",
      totalCount: 0,
      selectedInstitution: null,
    }
  },

  watch: {
    currentPage: function () {
      if (!isNaN(this.currentPage)) {
      }
    },
    accounts_meta: function (newVal) {
      this.totalCount = newVal ? newVal.total : 0
    },
  },

  mounted() {
    this.onCreated()
    if (!this.paging) {
      this.perPage = 0;
    } else {
      this.perPage = this.paging
    }
    this.totalCount = this.accounts_meta ? this.accounts_meta.total : 0
    if (this.accounts_meta) {
      this.currentPage = this.accounts_meta.currentSkip / this.accounts_meta.currentTake + 1;
    }
  },

  computed: {
    isLastPage() {
      return Math.floor(this.totalCount / this.perPage) === this.currentPage - 1
    },

    institutions() {
      return this.$store.state.institution ? this.$store.state.institution.institutions : []
    },
  },

  methods: {

    onCreated() {
      if (!moduleInstitutions.isRegistered) {
        this.$store.registerModule("institution", moduleInstitutions);
        moduleInstitutions.isRegistered = true
      }
      this.getInstitutions({take: -1, skip: 0});
    },

    filterTable(clear = false) {
      if (clear) {
        this.selectedInstitution = null
      }
      this.currentPage = 1
      this.$emit("updateTable", clear ? {} : {institutionId: this.selectedInstitution});
    },

    warning(data) {
      this.$swal({
        title: "<span class=\"font-medium-1\">დარწმუნებული ხარ რომ გსურს წაშლა?</span>",
        icon: "warning",
        html:
            "<span class=\"font-small-3\">წაშლის შემდეგ ინფორმაციის აღდგენა შეუძლებელია</span>",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "დიახ წაშალე",
        cancelButtonText: "გაუქმება",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((value) => {
        if (value.isConfirmed) {
          this.$store.dispatch("patients/deletePatient", data.item.id).then(() => {
            this.$emit("updateTable");
          }).catch((err) => {
          });
        }
      });
    },

    formatDate(date) {
      let a = [{day: "2-digit"}, {month: "2-digit"}, {year: "numeric"}];
      if (date) return this.join(new Date(date), a, ".");
      return ""
    },

    join(t, a, s) {

      function format(m) {
        let f = new Intl.DateTimeFormat("en", m);
        return f.format(t);
      }

      return a.map(format).join(s);
    },

    rowClickHandler(record) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("redirect", record);
    },

    pageChanged(bvEvent, page) {
      let payload = {
        skip: (page - 1) * this.perPage
      }
      if (this.searchQuery) payload["q"] = this.searchQuery
      if (this.selectedInstitution) payload["institutionId"] = this.selectedInstitution
      this.$emit("updateTable", payload);
    },

    getInstitutions(payload = {}) {
      // this.tableVisible = false;
      return this.$store.dispatch("institution/getInstitutions", payload).then((response) => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },
  }
}
</script>

<style>

.index-container.table-responsive-sm .table td[aria-colindex='5'] {
  text-align: right;
}

.index-container.table-responsive-sm .table th[aria-colindex='5'] div {
  display: none;
}


.patient-container.table-responsive-sm .table td[aria-colindex='5'] {
  text-align: right;
}

.patient-container.table-responsive-sm .table th[aria-colindex='5'] div {
  display: none;
}


.contacts-container.table-responsive-sm .table td[aria-colindex='6'] {
  text-align: right;
}

.contacts-container.table-responsive-sm .table th[aria-colindex='6'] div {
  display: none;
}

.card .table tbody tr:last-child td:first-child {
  font-weight: normal !important;
}
</style>
